import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import { THEME_COLOR } from "../../../../styles/colors";

const ComparisonCard = ({ title, optionA, optionB }) => (
  <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.MIST_GRAY, boxBorderRadiusOutline: 12 }}>
    <Box type="outline" spacingInset="400">
      <Column spacing="300">
        {title && <Text type="h100">{title}</Text>}
        <Row spacing="100">
          <Column width="50%" spacing="200">
            {optionA?.label && <Text type="h50">{optionA.label}</Text>}
            {optionA?.points?.length > 0 && (
              <Text type="b200" color="secondary" tag="ul">
                {optionA.points.map((p, i) => <li key={i}>{p}</li>)}
              </Text>
            )}
          </Column>
          <Box backgroundColor={THEME_COLOR.MIST_GRAY} width={1} />
          <Column width="50%" spacing="200">
            {optionB?.label && <Text type="h50">{optionB.label}</Text>}
            {optionB?.points?.length > 0 && (
              <Text type="b200" color="secondary" tag="ul">
                {optionB.points.map((p, i) => <li key={i}>{p}</li>)}
              </Text>
            )}
          </Column>
        </Row>
      </Column>
    </Box>
  </Theme>
);

export default ComparisonCard;
